import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ThemeService } from '@awo-care/utils';
import { versionEmployee } from 'package.json';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  template: ` <router-outlet /> `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  private themeService = inject(ThemeService);

  constructor() {
    console.log(
      `%c AWO Care Employee UI %cv${versionEmployee}`,
      'background: #1976d2; color: white; padding: 2px 6px; font-weight: bold;',
      'background: #424242; color: white; padding: 2px 6px;'
    );
    this.themeService.initializeTheme('brand-theme');
  }

  ngOnInit() {
    setTimeout(() => {
      const splashScreen = document.getElementById('splash-screen');
      if (splashScreen) {
        splashScreen.classList.add('hide');
        setTimeout(() => splashScreen.remove(), 500);
      }
    }, 500);
  }
}
